// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__2Zkr4","content":"PrivacyPolicyPage_content__1egZ5"};